"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _underscore = require("underscore");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _ArrayUtils = require("FormsCommonUtils/ArrayUtils");

var _AddMoreOptionsModal = _interopRequireDefault(require("./AddMoreOptionsModal"));

var _CustomDragLayer = _interopRequireDefault(require("FormsCommonComponents/editor/draggable/CustomDragLayer"));

var _DraggablePropertyOption = _interopRequireDefault(require("FormsCommonComponents/editor/draggable/DraggablePropertyOption"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _UITable = _interopRequireDefault(require("UIComponents/table/UITable"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var NUM_FIRST_OPTIONS_SHOWN = 5;

var ConfigurationPropertyOptionsTable =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(ConfigurationPropertyOptionsTable, _React$PureComponent);
  (0, _createClass2.default)(ConfigurationPropertyOptionsTable, null, [{
    key: "propTypes",
    get: function get() {
      return {
        formField: _react.default.PropTypes.object.isRequired,
        properties: _react.default.PropTypes.array.isRequired,
        getPropertyEditorRoute: _react.default.PropTypes.func.isRequired,
        getPersonaEditorRoute: _react.default.PropTypes.func.isRequired,
        allowPropertyEdits: _react.default.PropTypes.bool.isRequired,
        use: _react.default.PropTypes.string,
        hasOwnDragLayer: _react.default.PropTypes.bool,
        handleUpdate: _react.default.PropTypes.func
      };
    }
  }]);

  function ConfigurationPropertyOptionsTable(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ConfigurationPropertyOptionsTable);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ConfigurationPropertyOptionsTable).call(this, props));
    _this.state = {
      openModal: false,
      selectedOptionsToAdd: [],
      showAllOptions: false,
      options: props.formField.options || []
    };
    _this.removeOption = _this.removeOption.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateSelectedOptions = _this.updateSelectedOptions.bind((0, _assertThisInitialized2.default)(_this));
    _this.toggleShowAllOptions = _this.toggleShowAllOptions.bind((0, _assertThisInitialized2.default)(_this));
    _this.addSelectedOptions = _this.addSelectedOptions.bind((0, _assertThisInitialized2.default)(_this));
    _this.openOrCloseModal = _this.openOrCloseModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleNameUpdate = _this.handleNameUpdate.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleReorder = _this.handleReorder.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleReorderDebounced = (0, _underscore.debounce)(_this.handleReorder, 10);
    _this.handleReorderFinish = _this.handleReorderFinish.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateShowAllOptionTrue = _this.updateShowAllOptionTrue.bind((0, _assertThisInitialized2.default)(_this));
    _this.findPreselectedOptions = _this.findPreselectedOptions.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ConfigurationPropertyOptionsTable, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      this.setState({
        options: props.formField.options
      });
    }
  }, {
    key: "langKey",
    value: function langKey(suffix) {
      return "editor.form.config." + suffix;
    }
  }, {
    key: "getEditPropertyOptionsLink",
    value: function getEditPropertyOptionsLink(name, propertyObjectType) {
      var _this$props = this.props,
          getPersonaEditorRoute = _this$props.getPersonaEditorRoute,
          getPropertyEditorRoute = _this$props.getPropertyEditorRoute;
      var route = (0, _underscore.isEqual)(name, 'hs_persona') ? getPersonaEditorRoute() : getPropertyEditorRoute(name, propertyObjectType);
      return _react.default.createElement(_UILink.default, {
        external: true,
        href: route
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('editPropertyOptions')
      }));
    }
  }, {
    key: "openOrCloseModal",
    value: function openOrCloseModal() {
      var openModal = this.state.openModal;
      this.setState({
        openModal: !openModal
      });
    }
  }, {
    key: "addSelectedOptions",
    value: function addSelectedOptions(allOptions) {
      var _this$props2 = this.props,
          formField = _this$props2.formField,
          handleUpdate = _this$props2.handleUpdate;
      var options = formField.options;
      this.state.selectedOptionsToAdd.forEach(function (selectedOption) {
        var option = (0, _underscore.findWhere)(allOptions, {
          value: selectedOption
        });
        options.push(option);
      });
      options = (0, _underscore.sortBy)(options, function (option) {
        return option.displayOrder;
      });
      this.setState({
        selectedOptionsToAdd: [],
        openModal: false
      });
      handleUpdate(formField.set('options', options));
    }
  }, {
    key: "handleNameUpdate",
    value: function handleNameUpdate(internalValue, value) {
      var _this$props3 = this.props,
          formField = _this$props3.formField,
          handleUpdate = _this$props3.handleUpdate;
      var updatedOptions = [];
      formField.options.forEach(function (option) {
        if ((0, _underscore.isEqual)(option.value, internalValue)) {
          var updatedOption = Object.assign({}, option, {
            label: value
          });
          updatedOptions.push(updatedOption);
        } else {
          updatedOptions.push(option);
        }
      });
      handleUpdate(formField.set('options', updatedOptions));
    }
  }, {
    key: "findPreselectedOptions",
    value: function findPreselectedOptions(value) {
      var formField = this.props.formField;
      var selectedOptions = (0, _underscore.clone)(formField.selectedOptions);
      var index = formField.selectedOptions.indexOf(value);

      if (index !== -1) {
        selectedOptions.splice(index, 1);
      } else {
        selectedOptions = (0, _underscore.isEqual)('checkbox', formField.fieldType) ? selectedOptions.concat([value]) : [value];
      }

      return selectedOptions;
    }
  }, {
    key: "removeOption",
    value: function removeOption(index) {
      var _this$props4 = this.props,
          formField = _this$props4.formField,
          handleUpdate = _this$props4.handleUpdate;
      var options = (0, _underscore.clone)(formField.options);
      options.splice(index, 1);
      var changedOption = formField.options.find(function (k) {
        return formField.options.indexOf(k) === index;
      }).value;

      if (formField.selectedOptions.find(function (opt) {
        return opt === changedOption;
      })) {
        var selectedOptions = this.findPreselectedOptions(changedOption);
        handleUpdate(formField.set('options', options).set('selectedOptions', selectedOptions));
      } else {
        handleUpdate(formField.set('options', options));
      }
    }
  }, {
    key: "updateSelectedOptions",
    value: function updateSelectedOptions(option) {
      var selectedOptionsToAdd = this.state.selectedOptionsToAdd;
      var index = selectedOptionsToAdd.indexOf(option);

      if (index !== -1) {
        this.setState({
          selectedOptionsToAdd: (0, _ArrayUtils.removeItemFromArray)(selectedOptionsToAdd, index)
        });
      } else {
        this.setState({
          selectedOptionsToAdd: selectedOptionsToAdd.concat([option])
        });
      }
    }
  }, {
    key: "updateShowAllOptionTrue",
    value: function updateShowAllOptionTrue() {
      this.setState({
        showAllOptions: true
      });
    }
  }, {
    key: "updatePreselectedOptions",
    value: function updatePreselectedOptions(value) {
      var _this$props5 = this.props,
          formField = _this$props5.formField,
          handleUpdate = _this$props5.handleUpdate;
      var selectedOptions = this.findPreselectedOptions(value);
      handleUpdate(formField.set('selectedOptions', selectedOptions));
    }
  }, {
    key: "handleReorder",
    value: function handleReorder(draggedValue, droppedValue) {
      var options = this.props.formField.options;
      var draggedItem = (0, _underscore.findWhere)(options, {
        value: draggedValue
      });
      var droppedItem = (0, _underscore.findWhere)(options, {
        value: droppedValue
      });
      var newOptions = (0, _underscore.clone)(options);
      newOptions = (0, _ArrayUtils.removeItemFromArray)(newOptions, options.indexOf(draggedItem));
      newOptions = (0, _ArrayUtils.addItemToArray)(newOptions, options.indexOf(droppedItem), draggedItem);

      if ((0, _underscore.isEqual)(options, newOptions)) {
        return;
      }

      var updatedOptions = newOptions.map(function (opt, i) {
        return Object.assign({}, opt, {
          displayOrder: i
        });
      });
      this.setState({
        options: updatedOptions
      });
    }
  }, {
    key: "handleReorderFinish",
    value: function handleReorderFinish() {
      var _this$props6 = this.props,
          formField = _this$props6.formField,
          handleUpdate = _this$props6.handleUpdate;
      var options = this.state.options;
      handleUpdate(formField.set('options', options));
    }
  }, {
    key: "toggleShowAllOptions",
    value: function toggleShowAllOptions() {
      var showAllOptions = this.state.showAllOptions;
      this.setState({
        showAllOptions: !showAllOptions
      });
    }
  }, {
    key: "getAllOptions",
    value: function getAllOptions(name, propertyObjectType) {
      var properties = this.props.properties;
      var property = (0, _underscore.findWhere)(properties, {
        name: name,
        propertyObjectType: propertyObjectType
      });
      return property ? property.options : [];
    }
  }, {
    key: "maybeRenderUnusedOptionsCard",
    value: function maybeRenderUnusedOptionsCard(formField) {
      var allOptions = this.getAllOptions(formField.name, formField.propertyObjectType).filter(function (o) {
        return !o.hidden;
      });
      var unusedOptions = (0, _underscore.difference)((allOptions || []).map(function (el) {
        return el.value;
      }), (formField.options || []).map(function (el) {
        return el.value;
      }));

      if (!(0, _underscore.isEmpty)(unusedOptions)) {
        var maybeOptionsModal = this.maybeRenderAddMoreOptionsModal(formField, allOptions, unusedOptions);
        return _react.default.createElement("div", null, _react.default.createElement(_UICardWrapper.default, {
          compact: true
        }, _react.default.createElement(_UICardSection.default, {
          flush: true
        }, _react.default.createElement(_UIButton.default, {
          size: "extra-small",
          use: "tertiary-light",
          className: "add-options-button",
          onClick: this.openOrCloseModal
        }, _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('addOptions')
        })), _react.default.createElement(_Small.default, {
          use: "help"
        }, _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('unusedOptionsAvailable')
        })))), maybeOptionsModal);
      }

      return null;
    }
  }, {
    key: "maybeRenderAddMoreOptionsModal",
    value: function maybeRenderAddMoreOptionsModal(formField, allOptions, unusedOptions) {
      var _this$props7 = this.props,
          allowPropertyEdits = _this$props7.allowPropertyEdits,
          getPropertyEditorRoute = _this$props7.getPropertyEditorRoute;

      if (this.state.openModal) {
        return _react.default.createElement(_AddMoreOptionsModal.default, {
          formField: formField,
          allOptions: allOptions,
          unusedOptions: unusedOptions,
          addSelectedOptions: this.addSelectedOptions,
          updateSelectedOptions: this.updateSelectedOptions,
          closeModal: this.openOrCloseModal,
          getPropertyEditorRoute: getPropertyEditorRoute,
          allowPropertyEdits: allowPropertyEdits
        });
      }

      return null;
    }
  }, {
    key: "maybeRenderShowMoreButton",
    value: function maybeRenderShowMoreButton(showMore) {
      var message = showMore ? this.langKey('seeLess') : this.langKey('seeMore');
      return _react.default.createElement(_UIButton.default, {
        use: "link",
        className: "property-options-show-more-button",
        onClick: this.toggleShowAllOptions
      }, _react.default.createElement(_FormattedMessage.default, {
        message: message
      }));
    }
  }, {
    key: "renderRows",
    value: function renderRows(formField, showAllOptions) {
      var _this2 = this;

      var selectedOptions = this.props.formField.selectedOptions;
      var options = this.state.options;
      var optionsToShow = showAllOptions ? options : (0, _underscore.first)(options, NUM_FIRST_OPTIONS_SHOWN);
      return optionsToShow.map(function (option, index) {
        return _react.default.createElement(_DraggablePropertyOption.default, {
          selectedOptions: selectedOptions,
          option: option,
          key: index,
          updateLabel: function updateLabel(newValue) {
            return _this2.handleNameUpdate(option.value, newValue);
          },
          updatePreselected: function updatePreselected() {
            return _this2.updatePreselectedOptions(option.value);
          },
          removeOption: function removeOption() {
            return _this2.removeOption(index);
          },
          onReorder: _this2.handleReorderDebounced,
          onDrag: _this2.updateShowAllOptionTrue,
          onDrop: _this2.handleReorderFinish
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          allowPropertyEdits = _this$props8.allowPropertyEdits,
          formField = _this$props8.formField,
          use = _this$props8.use,
          hasOwnDragLayer = _this$props8.hasOwnDragLayer;
      var showAllOptions = this.state.showAllOptions;
      var options = formField.options;
      var displayShowMore = options.length > NUM_FIRST_OPTIONS_SHOWN;
      var showMoreClassName = !showAllOptions && displayShowMore ? 'property-options-list-show-more' : null;
      var editPropertyOptionsLink = this.getEditPropertyOptionsLink(formField.name, formField.propertyObjectType);
      var rows = this.renderRows(formField, showAllOptions);

      var selectOptions = _react.default.createElement(_UITable.default, {
        condensed: true,
        hover: false
      }, _react.default.createElement("thead", null, _react.default.createElement("tr", null, _react.default.createElement("th", null, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('preselect')
      })), _react.default.createElement("th", null, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('label')
      })), _react.default.createElement("th", null, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('internalValue')
      })), _react.default.createElement("th", null))), _react.default.createElement("tbody", null, rows));

      selectOptions = use === 'light' ? _react.default.createElement(_UICardWrapper.default, {
        className: (0, _classNames.default)('property-options-list', showMoreClassName)
      }, selectOptions) : _react.default.createElement("div", {
        className: (0, _classNames.default)('property-options-list', showMoreClassName)
      }, selectOptions);
      var maybeUnusedOptionsCard = this.maybeRenderUnusedOptionsCard(formField);
      return _react.default.createElement("div", {
        className: "config-input-field"
      }, _react.default.createElement(_UIFormControl.default, {
        help: allowPropertyEdits ? editPropertyOptionsLink : null,
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('propertyOptions')
        })
      }, selectOptions), displayShowMore && this.maybeRenderShowMoreButton(showAllOptions), maybeUnusedOptionsCard, !hasOwnDragLayer && _react.default.createElement(_CustomDragLayer.default, null));
    }
  }]);
  return ConfigurationPropertyOptionsTable;
}(_react.default.PureComponent);

exports.default = ConfigurationPropertyOptionsTable;
module.exports = exports.default;